import { SliceZone } from '@prismicio/react';
import { useRef } from 'react';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import smoothscroll from 'smoothscroll-polyfill';

import { BenefitsContractorsSlice } from './slices/BenefitsContractorsSlice';
import { CtaSlice } from './slices/CtaSlice';
import { CtaWithIllustrationSlice } from './slices/CtaWithIllustrationSlice';
import { FAQSlice } from './slices/FAQSlice';
import { FaqWithIconsSlice } from './slices/FaqWithIconsSlice';
import { HeroSlice } from './slices/HeroSlice';
import { InvoiceSlice } from './slices/InvoiceSlice';
import { OverviewSlice } from './slices/OverviewSlice';
import { OverviewSliceWithCtaSlice } from './slices/OverviewSliceWithCtaSlice';
import { PrimaryCtaSlice } from './slices/PrimaryCtaSlice';
import { ProcessSlice } from './slices/ProcessSlice';
import { ResourcesSlice } from './slices/ResourcesSlice';
import { ServicesSlice } from './slices/ServicesSlice';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

const components = {
  hero_section: HeroSlice,
  single_row_section: InvoiceSlice,
  faq_with_icons: FaqWithIconsSlice,
  manage_payroll_section: ServicesSlice,
  cta_section: CtaSlice,
  overview_section: OverviewSlice,
  benefits_country_contractors: BenefitsContractorsSlice,
  get_your_guide: CtaWithIllustrationSlice,
  overview_with_cta: OverviewSliceWithCtaSlice,
  step_progress_bar: ProcessSlice,
  read_more_slice: ResourcesSlice,
  bottom_cta_section: PrimaryCtaSlice,
  faqs: FAQSlice,
};

export function CountryContractorManagementPage(document) {
  const { body } = document;
  const applyFormRef = useRef();

  return (
    <>
      <DocumentHead document={document} />
      <SliceZone slices={body} components={components} context={{ applyFormRef }} />
    </>
  );
}
